import React from 'react'
import { Table, Button } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { dispatch } from '@rematch/core';
import LoadingComponent from '../../../common/LoadingComponent';
import { toastr } from 'react-redux-toastr';

class OrgUnitUserSearchTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            setRole: '',
        }
        this.handleSelect = this.handleSelect.bind(this);
    }
    componentWillMount() {
    }

    resendInvitation(invite) {
        invite.organizationId = this.props.organizationId;
        let message = <div className="confirmMessage">
            <h3>Resend Invitation</h3>
            <label>{invite.email}</label>
            <p>Are you sure that you wish to resend this invitation?</p>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                let organizationObj = {
                    "name": this.props.selectedOrganisation.name
                }
                let subject = this.props.teamDropdownDisableFlag && this.props.selectedSubOrg && this.props.selectedSubOrg.name ?
                    `You have been Invited to join the "${this.props.selectedSubOrg.name}" Team for "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
                    : `You have been Invited to join the "${this.props.selectedOrganisation.name}" Workspace on Aspenify platform.`
                let emailObject = {
                    templateName: "resendInviteMail",
                    toEmail: invite.email,
                    invite: invite,
                    invitationCode: invite._id,
                    fromUser: this.props.user,
                    organization: organizationObj,
                    subject: subject
                }
                dispatch.invite.resendInvitation(emailObject);
            }
        });

    }
    deleteInvitaion(userdata) {
        userdata.organizationId = this.props.organizationId;
        let message = <div className="confirmMessage">
            <h3>Delete Invitation</h3>
            <label>{userdata.firstName} {userdata.lastName}</label>
            <p>Are you sure that you wish to delete this invitation?</p>
            <span >This action is not reversible</span>
        </div>
        toastr.confirm(message, {
            onOk: () => {
                dispatch.invite.deleteInvitaionAsync(userdata);
                if (this.props.stringType === 'TeamMapping' || this.props.stringType === 'SubOrgUserAddModal') {
                    this.props.onClose();
                }
                else {
                    this.props.handleReset();
                }
            }
        });

    }
    async addUserInSubUnit(userData) {
        if (!this.state.setRole) {
            toastr.error('Message', 'Please select role.')
        } else {
            let formData = {}
            let teamId = this.props.selectedSubOrg._id;
            formData.accountId = this.props.match.params.accountId;
            formData.organizationId = this.props.match.params.workspaceId;
            formData.teamId = teamId;
            formData.from = this.props.user._id;
            formData.accountUserId = userData._id;
            formData.role = this.state.setRole;
            formData.parentOrganizationId = this.props.selectedSubOrg.parentOrganizationId;
            formData.stringType = this.props.stringType;
            formData.organizationName = this.props.selectedOrganisation.name;

            if (this.props.match.params.workspaceId === teamId) {
                formData.type = 'addUserInOrganization';
            }
            else {
                formData.type = 'addUserInSubOrganization';
                formData.teamName = this.props.selectedSubOrg.name;
            }
            let message = <div className="confirmMessage">
                <h3>Add User</h3>
                <label>{userData.firstName} {userData.lastName}</label>
                <p>Are you sure that you wish to add user?</p>
            </div>
            toastr.confirm(message, {
                onOk: async () => {
                    await dispatch.invite.addUserInSubUnitAsync(formData);
                    dispatch.community.addMainAreaContext('USERS');
                    if (this.props.stringType === 'TeamMapping' || this.props.stringType === 'SubOrgUserAddModal') {
                        if (this.props.stringType === 'SubOrgUserAddModal') {
                            for (let i = this.props.subOrgs.data.length; i--;) {
                                if (this.props.subOrgs.data[i]._id.toString() === this.props.selectedSubOrg._id.toString()) {
                                    let index = this.props.subOrgs.data.indexOf(this.props.subOrgs.data[i]);
                                    this.props.subOrgs.data[index].userCounts += 1;
                                    break;
                                }
                            }
                           
                        }
                        this.props.onClose();
                    }
                    else {
                        this.props.handleReset();
                        if (formData.organizationId.toString() === formData.teamId.toString()) {
                            if (this.state.setRole === 'workspaceOwner') {
                                await dispatch.users.userTreeSelectedPath("0/0")
                            }
                            else if (this.state.setRole === 'Manager') {
                                await dispatch.users.userTreeSelectedPath("0/1")
                            }
                            else if (this.state.setRole === 'Member') {
                                await dispatch.users.userTreeSelectedPath("0/2")
                            }
                            else {
                                await dispatch.users.userTreeSelectedPath("0")
                            }
                        }
                        else {
                            if (this.state.setRole === 'Manager') {
                                await dispatch.users.userTreeSelectedPath("0/0")
                            }
                            else if (this.state.setRole === 'Member') {
                                await dispatch.users.userTreeSelectedPath("0/1")
                            }
                            else {
                                await dispatch.users.userTreeSelectedPath("0")
                            }
                        }
                        await dispatch.users.storeUnitId(formData.teamId);
                        this.props.history.push(`/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_cm/userList/${this.props.match.params.teamId}/${this.state.setRole}`);
                    }
                }
            });

        }
    }

    handleSelect(data) {
        this.setState({ setRole: data.target.value })
    }

    render() {
        return (
            <div>
                <LoadingComponent active={this.props.addUserInSubUnitLoader}  message="Adding User" />
                {this.props.searchUserArr && this.props.searchUserArr.length > 0 ?
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={2}>First Name</Table.HeaderCell>
                                <Table.HeaderCell width={2}>Last Name</Table.HeaderCell>
                                <Table.HeaderCell width={4}>E-mail</Table.HeaderCell>
                                <Table.HeaderCell width={6}>Role</Table.HeaderCell>
                                <Table.HeaderCell width={2}>Actions</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {this.props.searchUserArr && this.props.searchUserArr.length > 0 &&
                                this.props.searchUserArr.map(function (user, index) {
                                    return (
                                        <Table.Row key={index}>
                                            <Table.Cell>{user.firstName}</Table.Cell>
                                            <Table.Cell>{user.lastName}</Table.Cell>
                                            <Table.Cell>{user.email}</Table.Cell>
                                            <Table.Cell>
                                                <div>
                                                    {!this.props.teamDropdownDisableFlag && this.props.teamId === null ?
                                                        <label> &nbsp;
                                                        <input type="radio"
                                                                label='Workspace Owner'
                                                                name='radioGroup'
                                                                value='workspaceOwner'
                                                                onClick={(data) => { this.handleSelect(data) }}
                                                            /> &nbsp;
                                                            Workspace Owner
                                                       </label>
                                                        :
                                                        <label> &nbsp;
                                                        <input type="radio"
                                                                label='Manager'
                                                                name='radioGroup'
                                                                value='Manager'
                                                                onClick={(data) => { this.handleSelect(data) }}
                                                            /> &nbsp;
                                                            Manager
                                                    </label>
                                                    }
                                                    &nbsp;
                                                        <label> &nbsp;
                                                       <input type="radio"
                                                            label='Member'
                                                            name='radioGroup'
                                                            value='Member'
                                                            onClick={(data) => { this.handleSelect(data) }}
                                                        /> &nbsp;
                                                        Member
                                                       </label>
                                                </div>
                                            </Table.Cell>
                                            <Table.Cell>
                                                <div>
                                                    <Button icon='plus' color="green" size="mini" onClick={() => { this.addUserInSubUnit(user) }} />
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                }, this)}
                        </Table.Body>
                    </Table>
                    : ""
                }


                {this.props.searchInviteUserArr &&
                    this.props.searchInviteUserArr.length > 0 ?
                    <div>
                        <span style={{ "color": "#FFC68B", "marginTop": "30px" }}>Already Invited</span>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell width={2}>First Name</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>Last Name</Table.HeaderCell>
                                    <Table.HeaderCell width={4}>E-mail</Table.HeaderCell>
                                    <Table.HeaderCell width={6}>Role</Table.HeaderCell>
                                    <Table.HeaderCell width={2}>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>
                                {this.props.searchInviteUserArr.length > 0 ?
                                    this.props.searchInviteUserArr.map(function (invite, index) {
                                        return (
                                            <Table.Row key={index}>

                                                <Table.Cell>{invite.firstName}</Table.Cell>
                                                <Table.Cell>{invite.lastName}</Table.Cell>
                                                <Table.Cell>{invite.email}</Table.Cell>
                                                <Table.Cell>{invite.role}</Table.Cell>
                                                <Table.Cell>
                                                    <div>
                                                        <Button icon='redo' color="blue" size="mini" onClick={() => { this.resendInvitation(invite) }} />
                                                        <Button className="trash-color" icon='trash alternate' size="mini" onClick={() => { this.deleteInvitaion(invite) }} />
                                                    </div>
                                                </Table.Cell>
                                            </Table.Row>
                                        );
                                    }, this) : <Table.Row ><Table.Cell style={{ 'text-align': 'center' }} colSpan='6'>No record found</Table.Cell></Table.Row>}
                            </Table.Body>
                        </Table>
                    </div>

                    : ""
                }

            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        inviteObj: state.invite.inviteObj,
        user: state.app.user,
        selectedOrganisation: state.app.selectedOrganisation,
        userObj: state.users.userObj
    };
}
const connectedLoginPage = connect(mapStateToProps)(OrgUnitUserSearchTable);
export default connectedLoginPage